module.exports = __webpack_public_path__ + "static/12-Small dish w_flower-01d442d7303b207d59c5b2bc3bfe75e9.jpg";